import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { addToCartStatusChangeMilliseconds } from '@velasca/constants'
import { useCart } from '@velasca/hooks/use-cart'
import { PlusIconSmall } from '@velasca/icons/plus-small'
import type { Product, ProductSize, Status } from '@velasca/types'
import { SansText } from '@velasca/ui/sans-text'
import { handleError } from '@velasca/utils/handle-error'
import { Button } from './SuggestedHorizontalProduct.styles'

interface QuickAddSimpleProductButtonProps {
  size: ProductSize
  handle: Product['handle']
  shouldOpenCartDrawerOnAddToCart?: boolean
  onQuickAdd?: (handle: Product['handle']) => void
}

export const QuickAddSimpleProductButton = ({
  size,
  handle,
  shouldOpenCartDrawerOnAddToCart,
  onQuickAdd,
}: QuickAddSimpleProductButtonProps) => {
  const { t } = useTranslation('product')
  const { addToCart, setIsDrawerOpen } = useCart()
  const [quickAddState, setQuickAddState] = useState<Status>('idle')
  const [isDrawerOpenable, setIsDrawerOpenable] = useState(false)

  // Spostare in uno useEffect l'apertura del drawer fa sì che lo useScrollLock dentro MobilePopup abbia il tempo
  // di sbloccare il body.
  useEffect(() => {
    if (isDrawerOpenable) {
      setIsDrawerOpen(true)
    }
  }, [isDrawerOpenable, setIsDrawerOpen])

  return (
    <Button
      disabled={size.quantityAvailable === 0 || quickAddState === 'loading'}
      onClick={() => {
        addToCart(size.id, 1)
          .then(() => {
            setQuickAddState('success')
            setTimeout(() => {
              window.location.pathname !== '/cart' &&
                shouldOpenCartDrawerOnAddToCart &&
                setIsDrawerOpenable(true)
            }, addToCartStatusChangeMilliseconds)
          })
          .catch((error) => {
            setQuickAddState('error')
            handleError(error, {
              message: "Couldn't add product to cart.",
            })
          })
          .finally(() => {
            setTimeout(() => {
              setQuickAddState('idle')
            }, addToCartStatusChangeMilliseconds)
          })

        onQuickAdd?.(handle)
      }}
    >
      <SansText uppercase as="span" size="sm">
        {size.quantityAvailable > 0
          ? t('addToCart')
          : t('temporarilyNotAvailable')}
      </SansText>
      {size.quantityAvailable > 0 && <PlusIconSmall width="18" height="18" />}
    </Button>
  )
}
